import { SubscriptionType } from "../types/company";
import { SubscriptionActions } from "../types/user";
import { hasSubscriptionAccess } from "../utils/subscription.utils";
import { useAuth } from "./useAuth";

export const useSubscription = () => {
  const { authInfo } = useAuth();

  const subscriptionTypes: SubscriptionType[] =
    authInfo.user?.company?.subscription_access_level ||
    authInfo.user?.company?.subscriptions || // To be deprecated
    [];

  const hasAccess = (action: SubscriptionActions): boolean => {
    return hasSubscriptionAccess(subscriptionTypes, action);
  };

  return {
    hasAccess,
    subscriptionTypes,
  };
};
